export enum EntityArchiveState {
  Active = 'active',
  Archived = 'archived',
}
